module.exports = __webpack_public_path__ + "static/media/酒店信息_03.eb21bd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotel/image/酒店信息_03.png
// module id = 1198
// module chunks = 0